import React, { useContext, useEffect } from "react";
import { EtatGlobalContext } from "../../../EtatGlobal";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
} from "../.././../../components/ui/table.js";

const abrvToDiligence = {
  remise: {
    diligence: "",
    honoraire: " ",
  },
};

const TableauDynamique = () => {
  const { rows, setRows, formData, setFormData, setNombreLignesTableau } =
    useContext(EtatGlobalContext);

  useEffect(() => {
    setNombreLignesTableau(rows.length);
  }, [rows, setNombreLignesTableau]);

  const addRow = () => {
    setRows([
      ...rows,
      { diligence: "", honoraire: "", abrv: "", suggestions: [] },
    ]);
  };

  const formatNombreEuro = (val) => {
    const num = parseFloat(val?.toString().replace(",", "."));
    if (isNaN(num)) return "";
    return (
      num
        .toFixed(2)
        .replace(".", ",")
        .replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " €"
    );
  };

  const updateRow = (index, field, value) => {
    const newRows = [...rows];

    if (field === "abrv") {
      let normalizedValue = value.trim().toLowerCase();
      normalizedValue = normalizedValue.replace(/^-\s*/, "");

      if (value.startsWith(" - ")) {
        value = " - " + value.charAt(3).toUpperCase() + value.slice(4);
      } else {
        value = value.charAt(0).toUpperCase() + value.slice(1);
      }

      newRows[index][field] = value;

      if (abrvToDiligence.hasOwnProperty(normalizedValue)) {
        newRows[index]["diligence"] =
          abrvToDiligence[normalizedValue].diligence;
        newRows[index]["honoraire"] = formatNombreEuro(
          abrvToDiligence[normalizedValue].honoraire
        );
      } else {
        newRows[index]["diligence"] = "";
        newRows[index]["honoraire"] = "";
      }

      if (value.startsWith("-")) {
        newRows[index]["diligence"] = " - " + newRows[index]["diligence"];
      }
    }

    if (field === "diligence" && !value.startsWith(" - ")) {
      value = " - " + value;
    }
    if (field === "abrv" && !value.startsWith(" - ")) {
      value = " - " + value;
    }

    if (
      field === "honoraire" &&
      newRows[index].abrv?.toLowerCase().includes("remise")
    ) {
      if (!value.startsWith("- ")) {
        value = "- " + value;
      }
    }
    if (field === "honoraire") {
      newRows[index][field] = value;
    }

    newRows[index][field] = value;
    setRows(newRows);
  };

  const deleteRow = (index) => {
    const newRows = rows.filter((_, i) => i !== index);
    setRows(newRows);
  };

  const handleAbbrvChange = (index, value) => {
    updateRow(index, "abrv", value);

    const newRows = [...rows];
    const trimmedValue = value.trim();
    const words = trimmedValue.split(" ");

    if (words.length > 1) {
      const lastWord = words[words.length - 1].toLowerCase();
      const filteredSuggestions = Object.keys(abrvToDiligence).filter((abrv) =>
        abrv.includes(lastWord)
      );
      newRows[index].suggestions = filteredSuggestions;
    } else {
      newRows[index].suggestions = [];
    }

    setRows(newRows);
  };

  const selectSuggestion = (index, suggestion) => {
    updateRow(index, "abrv", suggestion);
    const newRows = [...rows];
    newRows[index].suggestions = [];
    setRows(newRows);
  };

  const handleSuggestionClick = (index) => {
    const newRows = [...rows];
    const filteredSuggestions = Object.keys(abrvToDiligence);
    newRows[index].suggestions = filteredSuggestions;
    setRows(newRows);
  };

  useEffect(() => {
    const totalHT = rows.reduce((sum, row) => {
      const cleaned = row.honoraire
        .replace(/ /g, "")
        .replace(/\s/g, "")
        .replace(/[^\d,.-]/g, "")
        .replace(",", ".");
      const value = Math.abs(parseFloat(cleaned));

      if (isNaN(value)) return sum;

      if (row.abrv?.toLowerCase().includes("remise")) {
        return sum - value;
      }

      return sum + value;
    }, 0);

    const tvaPourcentStr = formData.TVA_honoraires_pourcentage?.replace(
      ",",
      "."
    );
    const tvaRate = parseFloat(tvaPourcentStr);
    const tva = isNaN(tvaRate) ? 0 : (totalHT * tvaRate) / 100;
    const totalTTC = totalHT + tva;

    setFormData((prevFormData) => ({
      ...prevFormData,
      total_honoraires: formatNombreEuro(totalHT),
      TVA_honoraires: formatNombreEuro(tva),
      total_honoraires_ttc: formatNombreEuro(totalTTC),
    }));
  }, [rows, formData.TVA_honoraires_pourcentage, setFormData]);

  return (
    <div className="space-y-4">
      <Table className="w-full border border-gray-300 border-collapse text-sm">
        <TableHead className="bg-gray-100">
          <TableRow>
            <TableHeaderCell className="border border-gray-300 px-3 py-2 text-center font-semibold">
              Abreviation
            </TableHeaderCell>
            <TableHeaderCell className="border border-gray-300 px-3 py-2 text-center font-semibold">
              Diligence
            </TableHeaderCell>
            <TableHeaderCell className="border border-gray-300 px-3 py-2 text-center font-semibold">
              Honoraire (€)
            </TableHeaderCell>
            <TableHeaderCell className="border border-gray-300 px-3 py-2 text-center font-semibold">
              Actions
            </TableHeaderCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={index} className="hover:bg-gray-50">
              <TableCell className="border border-gray-300 text-center px-2 py-1">
                <div
                  className="flex items-center justify-center gap-1"
                  style={{ flexDirection: "column", width: "100%" }}
                >
                  <div style={{ position: "relative", width: "100%" }}>
                    <input
                      type="text"
                      value={row.abrv}
                      onChange={(e) => handleAbbrvChange(index, e.target.value)}
                      className="w-4/5 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
                    />
                    <button
                      onClick={() => handleSuggestionClick(index)}
                      className="px-2 py-1 border border-gray-300 rounded-md hover:bg-gray-100"
                    >
                      ↓
                    </button>
                  </div>

                  {row.suggestions.length > 0 && (
                    <div className="top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow z-10">
                      {row.suggestions.map((suggestion, i) => (
                        <div
                          key={i}
                          onClick={() => selectSuggestion(index, suggestion)}
                          className="px-2 py-1 cursor-pointer hover:bg-gray-100"
                        >
                          {suggestion}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </TableCell>
              <TableCell className="border border-gray-300 text-center px-2 py-1">
                <textarea
                  className="w-[95%] px-2 py-1 border border-gray-300 rounded-md text-center focus:outline-none focus:ring-1 focus:ring-blue-400"
                  value={row.diligence}
                  onChange={(e) =>
                    updateRow(index, "diligence", e.target.value)
                  }
                  rows={2}
                />
              </TableCell>
              <TableCell className="border border-gray-300 text-center px-2 py-1">
                <input
                  className="w-[95%] px-2 py-1 border border-gray-300 rounded-md text-center focus:outline-none focus:ring-1 focus:ring-blue-400"
                  type="text"
                  value={
                    row.abrv?.toLowerCase().includes("remise") && row.honoraire
                      ? "- " + row.honoraire.replace(/^-\s*/, "")
                      : row.honoraire
                  }
                  onChange={(e) => {
                    let raw = e.target.value
                      .replace(/,/g, ".")
                      .replace(/[^\d.]/g, "");
                    if (!raw) {
                      updateRow(index, "honoraire", "");
                      return;
                    }
                    const parts = raw.split(".");
                    const formatted =
                      parts.length > 1
                        ? parts[0] + "," + parts[1].substring(0, 2)
                        : parts[0];
                    updateRow(index, "honoraire", formatted);
                  }}
                  onBlur={() => {
                    const cleaned = row.honoraire
                      .replace(/[^\d,]/g, "")
                      .replace(",", ".");
                    const num = parseFloat(cleaned);
                    if (!isNaN(num)) {
                      const final = num.toFixed(2).replace(".", ",");
                      let formatted = formatNombreEuro(final);
                      updateRow(index, "honoraire", formatted);
                    } else {
                      updateRow(index, "honoraire", "");
                    }
                  }}
                />
              </TableCell>

              <TableCell
                style={{ border: "1px solid black", textAlign: "center" }}
              >
                <button onClick={() => deleteRow(index)}>❌</button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <br />
      <button
        className="w-full h-10 flex items-center justify-center gap-3 border border-gray-300 rounded-xl text-sm font-medium hover:bg-gray-50 transition"
        onClick={addRow}
      >
        Ajouter une ligne
      </button>
      <div className="space-y-2 text-sm font-semibold">
        <p>
          Total des honoraires :{" "}
          <span className="ml-2 text-blue-600">
            {formData.total_honoraires}
          </span>
        </p>
        <p className="flex items-center gap-2">
          Taux de TVA :{" "}
          <input
            type="text"
            placeholder="8,50"
            value={formData.TVA_honoraires_pourcentage.replace(" %", "")}
            onChange={(e) => {
              let raw = e.target.value.replace(",", ".").replace(/[^\d.]/g, "");
              if (raw === "") {
                setFormData({ ...formData, TVA_honoraires_pourcentage: "" });
                return;
              }

              let num = parseFloat(raw);
              if (!isNaN(num)) {
                const parts = raw.split(".");
                let formatted =
                  parts.length === 2
                    ? parts[0] + "," + parts[1].substring(0, 2)
                    : parts[0];
                setFormData({
                  ...formData,
                  TVA_honoraires_pourcentage: formatted,
                });
              }
            }}
            onBlur={() => {
              let input = formData.TVA_honoraires_pourcentage.replace(
                ",",
                "."
              ).replace(/[^\d.]/g, "");
              let num = parseFloat(input);
              if (!isNaN(num)) {
                let formatted = num.toFixed(2).replace(".", ",");
                setFormData({
                  ...formData,
                  TVA_honoraires_pourcentage: `${formatted} %`,
                });
              } else {
                setFormData({
                  ...formData,
                  TVA_honoraires_pourcentage: "8,50 %",
                });
              }
            }}
            style={{ width: "60px", marginLeft: "5px" }}
          />
          %
        </p>

        <p className="flex items-center gap-2">
          TVA sur honoraires : {formData.TVA_honoraires}
        </p>

        <p className="flex items-center gap-2">
          Total TTC des honoraires : {formData.total_honoraires_ttc}
        </p>
      </div>
    </div>
  );
};

export default TableauDynamique;
